import React, { useState, useEffect } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
// const { SearchBar } = Search;

import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
// import moment from "moment/min/moment-with-locales";
import moment from "moment";
import "moment/locale/th";

moment.locale("th");

import { Row, Col } from "react-bootstrap";

// Import Service
// import RegsugarService from "../../services/regsugar.service";
import FarmerMasterService from "../../services/farmermaster.service";
import authService from "../../services/auth.service";
import approveService from "../../services/approve.service";
import TimeregService from "../../services/timereg.service";

//Import Modal
// import ModalContract from "./ModalContract";
import ModalMasterapprove from "./ModalMasterapprove";
import ModalViewMasterapprove from "./ModalViewMasterapprove";

//Dwonload PDF
import DownloadPDF from "./DownloadPdf";

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";
import { toast } from "react-toastify";

const ApproveMasterlist = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  // const [showContract, setShowContract] = useState(false);
  // const [farmerselect, farmerSetselect] = useState({});
  const [showApprove, setShowApprove] = useState(false);
  const [master_select, setMaster_select] = useState({});
  const [showViewApprove, setShowViewApprove] = useState(false);
  const [master_selectView, setMaster_selectView] = useState({});
  const [currentTimeReg, setCurrentTimeReg] = useState({});

  // const [timeregSelect, setTimeregSelect] = useState(0);
  // const [timeregList, setTimeregList] = useState([]);

  const user = authService.getCurrentUser();

  // const getTimeRegList = () => {
  //   TimeregService.getTimereglist(user.user.user_reg)
  //     .then((response) => {
  //       setTimeregList(response.data.data);
  //     })
  //     .catch((err) => {
  //       console.log("fetch timereg List Error :" + err);
  //     });
  // };

  // const handleTimeregChange = (e) => {
  //   setTimeregSelect(e.target.value);
  //   getData(user.user.user_reg, e.target.value);
  // };

  const submitEditDetail = (obj) => {
    setLoading(true);
    approveService
      .approveMasterStatus({
        ...obj,
        user_id: user.user.user_id,
      })
      .then((response) => {
        if (response.data.success) {
          setData((obj) => [
            ...obj.map((item) => {
              if (item.masterid != response.data.data.masterid) {
                return item;
              } else {
                return response.data.data;
              }
            }),
          ]);
          setShowApprove(false);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    checkTimereg();
  }, []);

  const checkTimereg = () => {
    TimeregService.getLastCurrent()
      .then((response) => {
        if (response.data.success && response.data.data !== null) {
          setCurrentTimeReg(response.data.data);
          getData(user.user.user_reg, response.data.data.timereg_id);
        } else {
          setCurrentTimeReg({ message: "ไม่มีรอบให้จดทะเบียน" });
        }
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
      });
  };
  const getData = (assoc_id, timereg_id) => {
    setLoading(true);
    FarmerMasterService.getFarmerMasterForRegistrar(assoc_id, timereg_id)
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const clickApprove = (row) => {
    setMaster_select(row);
    setShowApprove(true);
  };
  const clickViewApprove = (row) => {
    setMaster_selectView(row);
    setShowViewApprove(true);
  };
  // const clickContract = (row) => {
  //   farmerSetselect({
  //     masterid: row.masterid,
  //     person_card_id: row.masteridcard,
  //     approve_status: row.approve_status,
  //   });
  //   setShowContract(true);
  // };
  const ActionsEdit = (row) => {
    return (
      <>
        {/* <i
          className="bi bi-search custom-icon-table"
          onClick={() => clickContract(row.row)}
        ></i> */}

        {row.row.approve_status == "อนุมัติ" ||
        row.row.approve_status == "ไม่อนุมัติ" ? (
          <i
            className="bi bi-search custom-icon-table"
            onClick={() => clickViewApprove(row.row)}
          ></i>
        ) : (
          <i
            className="bi bi-pencil custom-icon-table"
            onClick={() => clickApprove(row.row)}
          ></i>
        )}
        {row.row.farmer_card != "-" ? (
          <DownloadPDF card={row.row.farmer_card} idno={row.row.masteridcard} />
        ) : (
          ""
        )}
      </>
    );
  };

  const actionsEdittFormatter = (cell, row) => {
    return <ActionsEdit row={row} />;
  };

  const columns = [
    {
      text: "masterid",
      dataField: "masterid",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "masteridcard",
      dataField: "masteridcard",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "ชื่อ-สกุล",
      dataField: "mastername",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "สร้างโดย",
      dataField: "user_create",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "12%" };
      },
      style: {
        wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "หน. กลุ่ม",
      dataField: "status_text",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "8%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      // style: {
      //   wordBreak: "break-word",
      // },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "ผลการพิจารณา",
      dataField: "approve_status",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "8%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "อนุมัติโดย",
      dataField: "approve_name",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    // {
    //   text: "เลขหัวหน้ากลุ่ม",
    //   dataField: "farmer_card",
    //   sort: true,
    //   editable: false,
    //   filter: textFilter({ placeholder: "ค้นหา" }),
    //   headerStyle: () => {
    //     return { textAlign: "center", width: "10%" };
    //   },
    //   style: {
    //     wordBreak: "break-word",
    //     textAlign: "center",
    //   },
    // },
    {
      text: "เริ่ม",
      dataField: "start_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      searchable: false,
      formatter: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "8%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "สิ้นสุด",
      dataField: "end_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      searchable: false,
      formatter: (cell, row) => {
        console.log(row);
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell, row) => {
        console.log(row);
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "8%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "หมายเหตุ",
      dataField: "comments",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "แก้ไข",
      dataField: "edit",
      isDummyField: true,
      editable: false,
      formatter: actionsEdittFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "13%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "<<",
    lastPageText: ">>",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  if (error) return `Error :${error}`;

  return (
    <div>
      {loading ? <LoadingAlert /> : ""}
      <ModalMasterapprove
        show={showApprove}
        hidden={setShowApprove}
        master_select={master_select}
        afterSubmit={submitEditDetail}
      />
      <ModalViewMasterapprove
        show={showViewApprove}
        hidden={setShowViewApprove}
        master_select={master_selectView}
      />
      {/* <ModalContract
        show={showContract}
        hidden={setShowContract}
        farmerselect={farmerselect}
      /> */}
      <ToolkitProvider
        bootstrap4
        keyField="regsugar_id"
        data={data}
        columns={columns}
        search
      >
        {(prop) => (
          <React.Fragment>
            <Row>
              <Col md={10}>
                {" "}
                {currentTimeReg.message ? (
                  <>
                    <span>{currentTimeReg.message}</span>
                  </>
                ) : (
                  <>
                    <span style={{ fontWeight: "bold" }}>
                      {currentTimeReg.timereg_desc}
                    </span>
                    <span>{" เริ่มวันที่ "}</span>
                    <span>
                      {moment(currentTimeReg.timereg_start)
                        .add(543, "year")
                        .locale("th")
                        .format("ll")}
                    </span>
                    <span>{" ถึงวันที่ "}</span>
                    <span>
                      {moment(currentTimeReg.timereg_stop)
                        .add(543, "year")
                        .locale("th")
                        .format("ll")}
                    </span>
                  </>
                )}
              </Col>
              <Col md={2}>
                {/* <div>
                  <div className="text-left">
                    <SearchBar {...prop.searchProps} />
                  </div>
                </div> */}
              </Col>
            </Row>

            <hr />
            <BootstrapTable
              // bootstrap4
              // keyField="farmer_id"
              // columns={columns}
              // data={data}
              pagination={pagination}
              //   cellEdit={cellEditFactory({
              //     mode: "click",
              //     blurToSave: true,
              //     afterSaveCell,
              //   })}
              filter={filterFactory()}
              // loading={true}
              {...prop.baseProps}
              // cellEdit={cellEditFactory({
              //   mode: "click",
              //   blurToSave: true,
              //   afterSaveCell: handleChange,
              //   beforeSaveCell: beforeSaveCell,
              // })}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default ApproveMasterlist;
